
import React from 'react'

 const Mangues = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44.665" height="63.85" viewBox="0 0 44.665 63.85">
    <g id="Group_18792" data-name="Group 18792" transform="translate(-318.847 -364.204)">
      <g id="Group_18791" data-name="Group 18791">
        <g id="Group_18789" data-name="Group 18789">
          <path id="Path_19906" data-name="Path 19906" d="M345,377.8c4.7.084,17.164,4.087,18.39,17.981s-6.845,25.439-14,29.525-13.792,3.065-15.733.511,2.146-10.523-.1-19.717c-1.02-4.174-4.393-8.991-4.189-14.916S333.556,377.6,345,377.8Z" fill="#eeb700"/>
        </g>
        <g id="Group_18790" data-name="Group 18790">
          <path id="Path_19907" data-name="Path 19907" d="M335.873,386.628c-1.429,1.911-1.3,4.613.283,5.531s4.021.113,5.451-1.8,1.306-4.2-.275-5.122A4.311,4.311,0,0,0,335.873,386.628Z" fill="#f7ca00"/>
          <path id="Path_19908" data-name="Path 19908" d="M336.968,395.9a1.65,1.65,0,0,0,.12,2.347,1.909,1.909,0,0,0,2.313-.763c.607-.81.554-1.783-.117-2.173A1.83,1.83,0,0,0,336.968,395.9Z" fill="#f7ca00"/>
        </g>
        <path id="Path_19909" data-name="Path 19909" d="M342.116,375.211s-6.321,3.324-11.564,1.685-7.585-11.423-11.705-12.687c0,0,12.079-.235,16.527,2.621S342.116,375.211,342.116,375.211Z" fill="#48a140"/>
      </g>
      <path id="Path_19910" data-name="Path 19910" d="M342.181,379.377c0,.278.619.5,1.383.5s1.383-.225,1.383-.5-.619-.5-1.383-.5S342.181,379.1,342.181,379.377Z" opacity="0.2"/>
    </g>
  </svg> 

  );
};
export default Mangues
